import { ExternalProvider, Web3Provider } from "@ethersproject/providers";
import { StyledEngineProvider } from "@mui/material/styles";
import { Web3ReactProvider } from "@web3-react/core";
import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import FloatingCart from "./components/FloatingCart";
import Footer from "./components/Footer";
import { useAppContext } from "./contexts/App";
import Router from "./router";
import { CartItem } from "./types/Product";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function getLibrary(provider: ExternalProvider) {
  return new Web3Provider(provider);
}

function App() {
  const appContext = useAppContext();

  useEffect(() => {
    if (!appContext) return;

    const storedProducts = localStorage.getItem("cart");
    const parsedProducts: CartItem[] = JSON.parse(storedProducts || "[]");

    appContext.setCartItemCount(parsedProducts.length);
  }, [appContext]);

  return (
    <QueryClientProvider client={queryClient}>
      <Web3ReactProvider getLibrary={getLibrary}>
        <StyledEngineProvider injectFirst>
          <BrowserRouter>
            <Router />
            <FloatingCart />
            <Footer />
          </BrowserRouter>
        </StyledEngineProvider>
      </Web3ReactProvider>
    </QueryClientProvider>
  );
}

export default App;
